import React, { createContext, useContext, useEffect, useState } from "react";

export const COUNTRIES = {
  GH: { code: "GH", name: "Ghana", flag: "🇬🇭", currency: "GHS", currencySymbol: "GH₵", exchangeRate: 15.5, dialCode: "+233" },
  NG: { code: "NG", name: "Nigeria", flag: "🇳🇬", currency: "NGN", currencySymbol: "₦", exchangeRate: 1600, dialCode: "+234" },
};

const CountryContext = createContext(undefined);

// Restaurant-only picker: no customer-account country lock here (that
// behavior belongs to the diner app's CountryProvider, not this one).
export function CountryProvider({ children }) {
  const [code, setCode] = useState(() => localStorage.getItem("cravve-country") || "GH");

  useEffect(() => {
    localStorage.setItem("cravve-country", code);
  }, [code]);

  const setCountry = (next) => {
    if (next !== "GH" && next !== "NG") return;
    setCode(next);
  };

  const country = COUNTRIES[code] || COUNTRIES.GH;

  return (
    <CountryContext.Provider value={{ country, setCountry }}>
      {children}
    </CountryContext.Provider>
  );
}

export function useCountry() {
  const ctx = useContext(CountryContext);
  if (!ctx) throw new Error("useCountry must be used within CountryProvider");
  return ctx;
}
